module.exports = __webpack_public_path__ + "assets/img/sad_baby.80e63152.jpg";